//引入接口文档
import req from '@/utils/req.js'

//教程类目-分页
export function pageCategory(params) {
  return req.get("/admin/tutorial/category/page", params);
}

//教程类目-详情
export function categoryDetail(id) {
  return req.get(`/admin/tutorial/category/${id}`);
}

//教程类目-添加
export function addCategory(params) {
  return req.post("/admin/tutorial/category", params);
}

//教程类目-更新
export function updateCategory(params) {
  return req.put("/admin/tutorial/category", params);
}

//教程类目-删除
export function delCategory(id) {
  return req.delete(`/admin/tutorial/category/${id}`);
}

//教程类目-排序
export function sortCategory(params) {
  return req.put("/admin/tutorial/category/sort", params);
}

//教程引导-分页
export function pageGuide(params) {
  return req.get("/admin/tutorial/guide/page", params);
}

//教程引导-详情
export function guideDetail(id) {
  return req.get(`/admin/tutorial/guide/${id}`);
}

//教程引导-添加
export function addGuide(params) {
  return req.post("/admin/tutorial/guide", params);
}

//教程引导-更新
export function updateGuide(params) {
  return req.put("/admin/tutorial/guide", params);
}

//教程引导-删除
export function delGuide(id) {
  return req.delete(`/admin/tutorial/guide/${id}`);
}

//教程引导-状态启用
export function enabledGuide(params) {
  return req.put(`/admin/tutorial/guide/enabled/${params}`);
}

//教程引导-状态停用
export function disabledGuide(params) {
  return req.put(`/admin/tutorial/guide/disabled/${params}`);
}
